<mat-dialog-content>
  <fa-icon [icon]="['fas', 'info-circle']" matTooltip="{{ 'setup_metadata_help' | translate }}" class="float-right text-primary"></fa-icon>
  <div class="alert alert-info" style="font-size: 12px;">
    <strong><fa-icon [icon]="['fas', 'info-circle']"></fa-icon></strong>&nbsp;{{ 'setup_metadata_help' | translate }}
  </div>
  <render-custom-metadata [fields]="fields" [driverId]="driverId" type="authentication" (event-status)="onMetadataUpdate($event)"></render-custom-metadata>
</mat-dialog-content>
